module.exports = __webpack_public_path__ + "image/update-agreement.2e9b398.png";